import React, { useState } from "react";
import axios from 'axios';
import * as conf from '../../../config/config';

const CodigoCelloInput = ({ incidencia, onGuardar }) => {
  const [valor, setValor] = useState(incidencia.codigoCello || "");
  const [error, setError] = useState("");
  const [guardando, setGuardando] = useState(false);

  const validar = (v) => {
    const codigo = v.trim();
    if (codigo === "") {
      setError("");
      return true;
    }
    if (codigo.length > 10) {
      setError("Máximo 10 caracteres");
      return false;
    }
    const num = parseInt(codigo, 10);
    if (!isNaN(num) && ((num >= 2 && num <= 11) || (num >= 21 && num <= 26))) {
      setError("Los códigos 2-11 y 21-26 están reservados para eventos principales");
      return false;
    }
    setError("");
    return true;
  };

  const handleGuardar = () => {
    if (!validar(valor)) return;
    setGuardando(true);
    setError("");
    const request = { ...incidencia, codigoCello: valor.trim() || null };
    axios.put(conf.api_raiz + "plataformasIncidencias", request)
      .then(() => {
        setGuardando(false);
        onGuardar(valor.trim());
      })
      .catch((err) => {
        setGuardando(false);
        const msg = err?.response?.data?.message || "Error al guardar el código Cello";
        setError(msg);
      });
  };

  return (
    <div>
      <label className="form-label">Código Cello (dejar vacío para no enviar a Cello)</label>
      <input
        type="text"
        className={"form-control" + (error ? " is-invalid" : "")}
        placeholder="Ej: 12, 13, 27..."
        value={valor}
        onChange={(e) => { setValor(e.target.value); setError(""); validar(e.target.value); }}
      />
      {error && <div className="invalid-feedback" style={{display: "block"}}>{error}</div>}
      <button className="btn btn-primary btn-sm mt-2" onClick={handleGuardar} disabled={!!error || guardando}>
        <i className={guardando ? "fa fa-spinner fa-spin" : "fa fa-save"}></i> {guardando ? "Guardando..." : "Guardar"}
      </button>
    </div>
  );
};

export default CodigoCelloInput;
